export default {
  "site.title": "Melhor CSSBuy Spreadsheet 2026 – Links Atualizados em Português",
  "site.description": "A maior coleção de links CSSBuy em português. Tênis, roupas, Yupoo e guias completos. Atualizado diariamente.",
  "hero.title.first": "Melhor CSSBuy Spreadsheet",
  "hero.title.second": "em Português 2026",
  "hero.subtitle": "A maior coleção de links CSSBuy atualizados diariamente. Tênis. Streetwear. Roupas. Yupoo. Produtos verificados.",
  "hero.cta.spreadsheet": "VER SPREADSHEET",
  "hero.cta.links": "ABRIR LINKS",
  "hero.cta.explore": "EXPLORAR AGORA",
  "hero.cta.cssbuy": "cssbuy sheet",
  "hero.cta.buy": "buy it now",
  "hero.free": "Comece agora gratuitamente.",
  "categories.title": "Categorias da CSSBuy Spreadsheet",
  "categories.subtitle": "Explore nossa coleção de links organizados por categoria",
  "categories.dropdown.placeholder": "Selecione uma categoria",
  "about.title": "O que é CSSBuy Spreadsheet",
  "about.description": "A CSSBuy Spreadsheet é a maior coleção de links organizados para compras internacionais. Reunimos milhares de links verificados de tênis, roupas, acessórios e muito mais, tudo atualizado diariamente para garantir que você encontre exatamente o que procura. Nossa planilha é 100% gratuita e em português, feita especialmente para a comunidade brasileira.",
  "about.stats.links": "5.000+ Links",
  "about.stats.categories": "14 Categorias",
  "about.stats.updated": "Atualizado Diariamente",
  "about.stats.verified": "Links Verificados",
  "trust.title": "Por que confiar na nossa Spreadsheet",
  "trust.item1.title": "Atualizado diariamente",
  "trust.item1.desc": "Links revisados todos os dias",
  "trust.item2.title": "Links verificados",
  "trust.item2.desc": "Cada link é testado antes de ser publicado",
  "trust.item3.title": "Guias seguros",
  "trust.item3.desc": "Tutoriais completos para iniciantes",
  "trust.item4.title": "Sem cadastro",
  "trust.item4.desc": "Acesso 100% gratuito e imediato",
  "trust.item5.title": "Em português",
  "trust.item5.desc": "Conteúdo feito para o Brasil",
  "faq.title": "Perguntas Frequentes",
  "faq.q1": "O CSSBuy é seguro?",
  "faq.a1": "Sim, o CSSBuy é um dos agentes de compras mais confiáveis do mercado, com anos de experiência e milhares de usuários satisfeitos. Todos os links da nossa spreadsheet são verificados.",
  "faq.q2": "Como usar a CSSBuy Spreadsheet?",
  "faq.a2": "Basta escolher uma categoria, clicar no link desejado e copiar para o CSSBuy. Nossos guias explicam o passo a passo completo para iniciantes.",
  "faq.q3": "A Spreadsheet é gratuita?",
  "faq.a3": "Sim! Nossa CSSBuy Spreadsheet é completamente gratuita. Não cobramos nada pelo acesso aos links e guias. Tudo é mantido pela comunidade.",
  "faq.q4": "Os links são atualizados?",
  "faq.a4": "Atualizamos nossa spreadsheet diariamente. Links quebrados são removidos e novos produtos são adicionados constantemente para manter a qualidade.",
  "faq.q5": "Qual o melhor agente em 2026?",
  "faq.a5": "O CSSBuy continua sendo uma das melhores opções em 2026, oferecendo ótimos preços de frete, suporte em inglês e uma interface fácil de usar.",
  "faq.q6": "Como comprar usando Yupoo?",
  "faq.a6": "Copie o link do Yupoo, cole no CSSBuy, preencha as informações do produto e aguarde o agente processar seu pedido. Temos guias detalhados no site.",
  "cta.title": "Pronto para começar?",
  "cta.subtitle": "Acesse agora a melhor CSSBuy Spreadsheet em português",
  "cta.button": "EXPLORAR LINKS",
  "footer.tagline": "Sua fonte confiável de links CSSBuy em português.",
  "footer.articles": "Artigos",
  "footer.article.cssbuy.spreadsheet": "CSSBuy Spreadsheet",
  "footer.article.cssbuy.seguro": "CSSBuy é Seguro",
  "footer.article.cssbuy.brasil": "CSSBuy Brasil",
  "footer.clothing": "Roupas",
  "footer.shoes": "Calçados",
  "footer.accessories": "Acessórios",
  "footer.copyright": "© 2026 cssbuyspreadsheets.lat. Todos os direitos reservados.",
  "footer.privacy": "Política de Privacidade",
  "nav.home": "Início",
  "nav.articles": "Artigos",
  "nav.categories": "Categorias"
}